export default "__VITE_ASSET__81c819e9__"